export default [
    {
        name: 'BMS Dashboard',
        icon: 'fa-building',
        baseTPL: `<style>
.carnot-live-html-widget .bms-dashboard {
    --bms-bg: #050914;
    --bms-panel: rgba(10, 20, 40, 0.82);
    --bms-blue: #00dce8;
    --bms-green: #00d967;
    --bms-red: #ff3158;
    --bms-text: #e0f8ff;
    --bms-muted: #7591aa;
    box-sizing: border-box;
    width: 100%;
    min-height: 640px;
    padding: 20px;
    color: var(--bms-text);
    font-family: "Courier New", monospace;
    background-color: var(--bms-bg);
    background-image:
        linear-gradient(rgba(0, 220, 232, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 220, 232, 0.05) 1px, transparent 1px);
    background-size: 30px 30px;
}
.carnot-live-html-widget .bms-dashboard * {
    box-sizing: border-box;
}
.carnot-live-html-widget .bms-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
    padding: 0 8px 16px;
    border-bottom: 2px solid var(--bms-blue);
    box-shadow: 0 5px 15px rgba(0, 220, 232, 0.1);
}
.carnot-live-html-widget .bms-title {
    color: var(--bms-blue);
    font-size: 26px;
    font-weight: 700;
    text-shadow: 0 0 10px rgba(0, 220, 232, 0.8);
}
.carnot-live-html-widget .bms-range {
    color: var(--bms-green);
    font-size: 14px;
    text-align: right;
}
.carnot-live-html-widget .bms-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
    padding-top: 18px;
}
.carnot-live-html-widget .bms-panel {
    position: relative;
    min-height: 220px;
    padding: 18px;
    overflow: hidden;
    background: var(--bms-panel);
    border: 1px solid rgba(0, 220, 232, 0.35);
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 220, 232, 0.2);
}
.carnot-live-html-widget .bms-panel::before,
.carnot-live-html-widget .bms-panel::after {
    position: absolute;
    width: 18px;
    height: 18px;
    content: "";
}
.carnot-live-html-widget .bms-panel::before {
    top: 0;
    left: 0;
    border-top: 2px solid var(--bms-blue);
    border-left: 2px solid var(--bms-blue);
}
.carnot-live-html-widget .bms-panel::after {
    right: 0;
    bottom: 0;
    border-right: 2px solid var(--bms-blue);
    border-bottom: 2px solid var(--bms-blue);
}
.carnot-live-html-widget .bms-panel-title {
    margin-bottom: 16px;
    padding-bottom: 7px;
    color: var(--bms-muted);
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    border-bottom: 1px dashed var(--bms-muted);
}
.carnot-live-html-widget .bms-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 14px;
    margin-bottom: 13px;
    font-family: sans-serif;
    font-size: 15px;
}
.carnot-live-html-widget .bms-value {
    color: var(--bms-blue);
    font-family: "Courier New", monospace;
    font-size: 20px;
    text-align: right;
}
.carnot-live-html-widget .bms-ok {
    color: var(--bms-green);
}
.carnot-live-html-widget .bms-warning {
    color: var(--bms-red);
    animation: bms-pulse 1.2s infinite;
}
.carnot-live-html-widget .bms-bar {
    width: 100%;
    height: 10px;
    margin-top: 5px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
}
.carnot-live-html-widget .bms-bar-fill {
    height: 100%;
    background: var(--bms-blue);
    box-shadow: 0 0 10px var(--bms-blue);
    transition: width 0.5s ease;
}
.carnot-live-html-widget .bms-scanner {
    position: relative;
    width: 130px;
    height: 130px;
    margin: 4px auto 12px;
    overflow: hidden;
    background: radial-gradient(circle, rgba(0, 217, 103, 0.12) 0%, transparent 70%);
    border: 1px solid var(--bms-green);
    border-radius: 50%;
}
.carnot-live-html-widget .bms-scanner::after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    height: 2px;
    content: "";
    background: var(--bms-green);
    transform-origin: 0 50%;
    animation: bms-scan 3s linear infinite;
}
.carnot-live-html-widget .bms-security {
    color: var(--bms-green);
    text-align: center;
}
@keyframes bms-pulse {
    50% { opacity: 0.45; }
}
@keyframes bms-scan {
    to { transform: rotate(360deg); }
}
@media (max-width: 1100px) {
    .carnot-live-html-widget .bms-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 680px) {
    .carnot-live-html-widget .bms-dashboard { min-height: 0; padding: 12px; }
    .carnot-live-html-widget .bms-header { align-items: flex-start; flex-direction: column; }
    .carnot-live-html-widget .bms-range { text-align: left; }
    .carnot-live-html-widget .bms-grid { grid-template-columns: 1fr; gap: 12px; }
    .carnot-live-html-widget .bms-panel { min-height: 0; }
}
</style>
<section class="bms-dashboard">
    <header class="bms-header">
        <div class="bms-title">SYS.BMS // {{ equipment || 'FACILITY' }}</div>
        <div class="bms-range">{{ dateRange ? dateRange.start + ' / ' + dateRange.end : 'CURRENT VALUES' }}</div>
    </header>
    <div class="bms-grid">
        <article class="bms-panel">
            <div class="bms-panel-title">HVAC Matrix</div>
            <div class="bms-row"><span>Internal Core Temp</span><span class="bms-value">{{ displayValue('Temperature', 1) }} F</span></div>
            <div class="bms-row"><span>Humidity</span><span class="bms-value">{{ displayValue('Humidity', 0) }}%</span></div>
            <div class="bms-row"><span>Air Quality</span><span class="bms-value bms-ok">{{ displayValue('Air Quality', null, 'Optimal') }}</span></div>
        </article>
        <article class="bms-panel">
            <div class="bms-panel-title">Energy Consumption</div>
            <div class="bms-row"><span>Main Grid Draw</span><span class="bms-value">{{ displayValue('Power', 0) }} kW</span></div>
            <div class="bms-bar"><div class="bms-bar-fill" :style="{ width: percent(latestValue('Power'), 5000) }"></div></div>
            <div class="bms-row" style="margin-top: 20px;"><span>Backup Generators</span><span class="bms-value">{{ displayValue('Generator Status', null, 'Standby') }}</span></div>
        </article>
        <article class="bms-panel">
            <div class="bms-panel-title">Security Perimeter</div>
            <div class="bms-scanner"></div>
            <div class="bms-security">{{ displayValue('Security Status', null, 'ALL ZONES SECURE') }}</div>
        </article>
        <article class="bms-panel">
            <div class="bms-panel-title">Lighting Nodes</div>
            <div class="bms-row"><span>Zone A (Lobby)</span><span class="bms-value">{{ displayValue('Lobby Lighting', 0, 100) }}%</span></div>
            <div class="bms-row"><span>Zone B (Offices)</span><span class="bms-value">{{ displayValue('Office Lighting', 0, 60) }}%</span></div>
            <div class="bms-row"><span>Zone C (Server Room)</span><span class="bms-value" :class="latestValue('Server Room Lighting') === 'FAULT' ? 'bms-warning' : ''">{{ displayValue('Server Room Lighting', null, 'FAULT') }}</span></div>
        </article>
        <article class="bms-panel">
            <div class="bms-panel-title">Vertical Transport</div>
            <div class="bms-row"><span>Car 1 (Express)</span><span class="bms-value">{{ displayValue('Elevator 1', null, 'FL 42 UP') }}</span></div>
            <div class="bms-row"><span>Car 2 (Local)</span><span class="bms-value">{{ displayValue('Elevator 2', null, 'FL 12 DOWN') }}</span></div>
            <div class="bms-row"><span>Car 3 (Freight)</span><span class="bms-value">{{ displayValue('Elevator 3', null, 'IDLE') }}</span></div>
        </article>
        <article class="bms-panel">
            <div class="bms-panel-title">Hydraulics &amp; Water</div>
            <div class="bms-row"><span>Main Valve Pressure</span><span class="bms-value">{{ displayValue('Pressure', 0) }} PSI</span></div>
            <div class="bms-bar"><div class="bms-bar-fill" :style="{ width: percent(latestValue('Pressure'), 150) }"></div></div>
        </article>
    </div>
</section>`,
    },
]